module.exports = __webpack_public_path__ + "static/img/lang-en.ec512f2a.svg";